export const DONE_REFRESHING_DATA = 'DONE_REFRESHING_DATA';
export const REFRESHING_DATA = 'REFRESHING_DATA';
